import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';

@Injectable({
  providedIn: 'root',
})
export class DevanningService {
  getToken = () => localStorage.getItem('Token');
  appJson = 'application/json';

  getBusinessEntity = () => localStorage.getItem('namcvalue');

  getBusinessEntityName = () => localStorage.getItem('namcName');

  getUserRole = () => localStorage.getItem('UserRoles');

  getUserUPN = () => localStorage.getItem('UPN');

  getWorkID = () => localStorage.getItem('workdayId');

  getUserName = () => localStorage.getItem('UserName');
  getApiHeaders = () => {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: this.getToken(),
      'X-Api-Key': this.environment.prodProgressKey
      
    });
  };

  httpCustomOptions = () => {
    return {
      headers: new HttpHeaders({
        'Content-Type': this.appJson,
        Accept: this.appJson,
        Authorization: this.getToken(),
        // 'X-Api-Key': this.environment.prodProgressKey
        'X-Api-Key': this.environment.stockingPaceKey
        
      }),
    };
  };

  httpCustomOptions1 = () => {
    return {
      params: {
        business_entity: this.getBusinessEntity(),
        user_role: this.getUserRole(),
        workid: this.getWorkID(),
      },
      headers: this.getApiHeaders(),
    };
  };
  private filterState = {
    containerFrom:  '',
    containerTo:  '',
    stockingDateFrom: '',
    stockingDateTo: ''
  };
  setFilters(filters: any) {
    this.filterState = { ...filters };
  }

  getFilters() {
    return this.filterState;
  }
  apiUrl = '';

  constructor(private http: HttpClient, private environment: EnvironmentConfiguration) {
    this.apiUrl = environment.devanningHistoryURL;

  }
  app;
  getContainerList(data): Observable<any> {
   return this.http.post<any>(`${this.apiUrl}/listContainer`, data, this.httpCustomOptions());
  }
  getContainerAndStockingDateTo(data): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/getContainerAndStockingDateTo`, data, this.httpCustomOptions());
  }
  // listLlpDocks(): Observable<any> {
  //   const data ={'business_enity':"02"}
  //   return this.http.post<any>(`${this.apiUrl}/listLlpDocks`, data, this.httpCustomOptions());
  // }
  getDevanningHistory(data): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/getDevanHistory`, data, this.httpCustomOptions());
  }

  // getContainerAndStockingDateTo(): Observable<any> {
  //   return this.http.get<any>(`${this.apiUrl}/getContainerAndStockingDateTo`, this.httpCustomOptions1());
  // }
 

 
}
